export default __webpack_public_path__ + "static/media/pt.645059c5.svg";